/**
 * Floating Menu Types
 */

/**
 * Single floating menu item from API
 */
export interface FloatingMenuItem {
  code: string;
  icon: string;
  status: boolean;
}

/**
 * @deprecated Use FloatingMenuItem[] instead - will be removed soon
 */
export interface FloatingMenuStatus {
  ACTION_MENU: boolean;
  AI_CHAT: boolean;
  SIDE_MENU: boolean;
  BLOCKSTREAM: boolean;
  MOJ_KALENDAR: boolean;
  CONTACTS: boolean;
}

export interface FloatingMenuResponse {
  /** @deprecated Use menu instead */
  status: FloatingMenuStatus;
  /** New menu array - use this */
  menu: FloatingMenuItem[];
}

export interface FloatingMenuPatchRequest {
  status: Partial<FloatingMenuStatus>;
}

/**
 * Default floating menu items
 */
export const DEFAULT_FLOATING_MENU: FloatingMenuItem[] = [
  { code: 'SIDE_MENU', icon: 'menu', status: false },
  { code: 'AI_CHAT', icon: 'message', status: false },
  { code: 'BLOCKSTREAM', icon: 'thunderbolt', status: false },
  { code: 'MOJ_KALENDAR', icon: 'calendar', status: false },
  { code: 'CONTACTS', icon: 'team', status: false },
];

/**
 * @deprecated Use DEFAULT_FLOATING_MENU instead
 */
export const DEFAULT_FLOATING_MENU_STATUS: FloatingMenuStatus = {
  ACTION_MENU: true,
  AI_CHAT: false,
  SIDE_MENU: false,
  BLOCKSTREAM: false,
  MOJ_KALENDAR: false,
  CONTACTS: false,
};
